/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/order */
import React, { useRef, useState } from 'react'
import {
  Box,
  ButtonBase,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'
import ReactInputMask from 'react-input-mask'
import Icon from '@mdi/react'
import { mdiProgressUpload } from '@mdi/js'
import axios from 'axios'

import FormSection from './FormSection'
import ufs from '../../../../util/uf'
import { isCpfCnpjValid } from '../../../../util/cpf_cnpj_validator'
import colors from '../../../../assets/colors'

const ACCEPTED_LOGO_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
]
const MAX_LOGO_SIZE = 5 * 1024 * 1024

const useStyles = makeStyles(theme => ({
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(3)}px`,
  },
  uploadLogo: {
    width: '100%',
    height: '62px',
    border: `1px dashed ${colors.grayMedium}`,
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    padding: `${theme.spacing(1)}px`,
    color: colors.primary,
    backgroundColor: '#FCFCFC',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      borderColor: colors.secondary,
      backgroundColor: '#FFF',
    },
  },
  uploadLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
  },
  logoValidate: {
    fontSize: '12px',
    lineHeight: '16px',
    color: colors.textPrimary,
  },
  logoError: {
    fontSize: '12px',
    lineHeight: '16px',
    color: colors.error,
  },
  boxLogo: {
    width: '100%',
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${colors.lightGray}`,
    borderRadius: '10px',
    padding: '4px',
  },
  logo: {
    objectFit: 'contain',
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: '8px',
  },
}))

const FormGroupLaundry = () => {
  const classes = useStyles()

  const [cpfCnpj, setCpfCnpj] = useState({
    error: false,
    text: 'Digite um CPF ou CNPJ',
  })
  const [logoValidate, setLogoValidate] = useState({
    invalidType: '',
  })
  const [ufError, setUfError] = useState(false)

  const [form, setForm] = useState({
    cep: '',
    city: '',
    uf: '',
    street: '',
    neighborhood: '',
    phone: '',
    cpf_cnpj: '',
  })

  const inputRef = useRef()

  const handlePhoneChange = e => {
    const { name, value } = e.target
    const phoneWithoutMask = value.replace(/\D/g, '')

    setForm({
      ...form,
      [name]: phoneWithoutMask,
    })
  }

  const resetLogo = message => {
    inputRef.current.value = ''
    setForm(prev => ({ ...prev, logo: null, logoPath: null }))
    setLogoValidate({ invalidType: message })
  }

  const handleChangeLogo = event => {
    const image = event.target.files[0]

    if (image == null) {
      return
    }

    if (!ACCEPTED_LOGO_TYPES.includes(image.type)) {
      resetLogo('Envie um arquivo JPG, PNG ou WEBP')
      return
    }

    if (image.size > MAX_LOGO_SIZE) {
      resetLogo('O logo deve ter no máximo 5 MB')
      return
    }

    const load = new FileReader()

    load.onload = e => {
      setForm(prev => ({ ...prev, logoPath: e.target.result }))
    }

    load.readAsDataURL(image)

    setForm(prev => ({ ...prev, logo: image }))
    setLogoValidate({ invalidType: '' })
  }

  const handleChooseFile = () => {
    inputRef.current.click()
  }

  const buscaCep = async cep => {
    const currentCep = cep?.replace(/\D/g, '')

    try {
      if (currentCep?.length == 8) {
        const resp = await axios
          .get(`https://viacep.com.br/ws/${currentCep}/json/`)
          .then(response => response?.data)

        setForm({
          ...form,
          city: resp?.localidade,
          uf: resp?.uf,
          street: resp?.logradouro,
          neighborhood: resp?.bairro,
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  const handleChangeCpf = e => {
    const { value } = e.target

    setForm(prev => ({ ...prev, cpf_cnpj: value }))
  }

  const handleValidCpfCnpj = e => {
    const digits = e.target.value.replace(/[^\d]/g, '')

    if (!digits.length) {
      return setCpfCnpj({ error: false, text: 'Digite um CPF ou CNPJ' })
    }

    if (digits.length != 11 && digits.length != 14) {
      return setCpfCnpj({ error: true, text: 'Informe o documento completo' })
    }

    if (!isCpfCnpjValid(e.target.value)) {
      return setCpfCnpj({
        error: true,
        text: digits.length == 11 ? 'CPF inválido' : 'CNPJ inválido',
      })
    }

    return setCpfCnpj({ error: false, text: '' })
  }

  const handleChange = e => {
    e.preventDefault()
    const { name, value } = e.target

    if (name == 'uf' && value) {
      setUfError(false)
    }

    setForm({
      ...form,
      [name]: value,
    })
  }

  return (
    <Box className={classes.group}>
      <FormSection
        title="Dados da lavanderia"
        caption="Informações que identificam a sua empresa no sistema."
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Nome"
              name="name"
              required
              fullWidth
              inputProps={{ maxLength: 100 }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="E-mail"
              name="email"
              type="email"
              required
              fullWidth
              inputProps={{ maxLength: 120 }}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <input
              ref={inputRef}
              name="logo"
              type="file"
              accept="image/jpeg,image/png,image/webp"
              onChange={handleChangeLogo}
              style={{ display: 'none' }}
            />
            <ButtonBase
              onClick={handleChooseFile}
              className={classes.uploadLogo}
            >
              <Box className={classes.uploadLabel}>
                <Icon path={mdiProgressUpload} size={1} />
                Upload logo
              </Box>
              <Typography
                className={
                  logoValidate?.invalidType
                    ? classes.logoError
                    : classes.logoValidate
                }
              >
                {logoValidate?.invalidType ||
                  'JPG, PNG ou WEBP · 169 x 32 · máx. 5 MB'}
              </Typography>
            </ButtonBase>
          </Grid>

          {form?.logoPath && (
            <Grid item xs={12} sm={12} md={6}>
              <Box className={classes.boxLogo}>
                <img alt="Logo" className={classes.logo} src={form?.logoPath} />
              </Box>
            </Grid>
          )}
        </Grid>
      </FormSection>

      <FormSection
        title="Endereço e contato"
        caption="Informe o CEP para preenchermos o endereço automaticamente."
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={3}>
            <ReactInputMask
              mask="99.999-999"
              name="cep"
              maskChar=""
              value={form?.cep}
              required
              onChange={handleChange}
              onBlur={() => buscaCep(form?.cep)}
            >
              {inputProps => (
                <TextField {...inputProps} label="CEP" fullWidth />
              )}
            </ReactInputMask>
          </Grid>

          <Grid item xs={12} sm={8} md={6}>
            <TextField
              label="Rua"
              name="street"
              fullWidth
              value={form?.street}
              onChange={handleChange}
              required
              inputProps={{ maxLength: 150 }}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Número"
              name="number"
              fullWidth
              required
              inputProps={{ maxLength: 10 }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="neighborhood"
              label="Bairro"
              onChange={handleChange}
              fullWidth
              required
              value={form?.neighborhood}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="complement"
              label="Complemento"
              fullWidth
              inputProps={{ maxLength: 255 }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              name="city"
              label="Cidade"
              onChange={handleChange}
              fullWidth
              required
              value={form?.city}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth required error={ufError}>
              <InputLabel id="self-registration-uf-label">UF</InputLabel>
              <Select
                labelId="self-registration-uf-label"
                id="self-registration-uf"
                value={form?.uf}
                fullWidth
                name="uf"
                onChange={handleChange}
                onBlur={() => setUfError(!form?.uf)}
              >
                {ufs?.map((uf, index) => {
                  return (
                    <MenuItem key={index} value={uf}>
                      {uf}
                    </MenuItem>
                  )
                })}
              </Select>
              {ufError && <FormHelperText>Selecione a UF</FormHelperText>}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <ReactInputMask
              mask={
                form?.phone?.replace(/[^\d]/g, '').length <= 10
                  ? '(99) 9999-9999?'
                  : '(99) 99999-9999'
              }
              formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
              name="phone"
              maskChar=""
              value={form?.phone}
              required
              onChange={handlePhoneChange}
            >
              {inputProps => (
                <TextField {...inputProps} label="Telefone" fullWidth />
              )}
            </ReactInputMask>
          </Grid>

          <Grid item xs={12} sm={6} md={5}>
            <ReactInputMask
              mask={
                form?.cpf_cnpj?.replace(/[^\d]/g, '').length <= 11
                  ? '999.999.999-99?'
                  : '99.999.999/9999-99'
              }
              formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
              maskChar=""
              name="cpf_cnpj"
              value={form?.cpf_cnpj}
              onChange={e => handleChangeCpf(e)}
              onPaste={e => {
                const digits = e.clipboardData
                  .getData('text')
                  .replace(/[^\d]/g, '')
                if (digits.length > 11) {
                  e.preventDefault()
                  const cnpj = digits
                    .slice(0, 14)
                    .replace(
                      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                      '$1.$2.$3/$4-$5'
                    )
                  setForm(prev => ({ ...prev, cpf_cnpj: cnpj }))
                }
              }}
              onBlur={e => handleValidCpfCnpj(e)}
              required
            >
              {inputProps => (
                <TextField
                  {...inputProps}
                  label="CPF/CNPJ"
                  fullWidth
                  error={cpfCnpj?.error}
                  helperText={cpfCnpj?.text}
                />
              )}
            </ReactInputMask>
          </Grid>
        </Grid>
      </FormSection>
    </Box>
  )
}

export default FormGroupLaundry
